import type React from 'react'

/** Muted heading for a group of Layout controls ("Alignment and Position", "Spacing", …). */
export function SectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <div>
      <label className="text-xs font-medium text-muted-foreground leading-normal">{children}</label>
    </div>
  )
}
